module.exports = __webpack_public_path__ + "assets/images/EUR005.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR005.png
// module id = 1358
// module chunks = 1